if (!customElements.get('wingpass-faq')) {
  customElements.define('wingpass-faq', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      const navigate = (id) => {
        const target = [...this.querySelectorAll('.wp-faq__category')].find((item) => item.id === id);
        if (!target) return;
        target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
        this.setActive(id);
      };
      this.querySelectorAll('[data-faq-target]').forEach((button) => {
        button.addEventListener('click', () => navigate(button.dataset.faqTarget), options);
      });
      this.querySelector('[data-faq-select]')?.addEventListener('change', (event) => navigate(event.target.value), options);
    }
    setActive(id) {
      this.querySelectorAll('[data-faq-target]').forEach((button) => {
        if (button.dataset.faqTarget === id) button.setAttribute('aria-current', 'true');
        else button.removeAttribute('aria-current');
      });
      const select = this.querySelector('[data-faq-select]');
      if (select) select.value = id;
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
}
